import { render, staticRenderFns } from "./buscaItensDespesas.vue?vue&type=template&id=1143a8f4&scoped=true"
import script from "./buscaItensDespesas.vue?vue&type=script&lang=js"
export * from "./buscaItensDespesas.vue?vue&type=script&lang=js"
import style0 from "./buscaItensDespesas.vue?vue&type=style&index=0&id=1143a8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1143a8f4",
  null
  
)

export default component.exports